import React$1 from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import Teaser$1 from '../Teaser/Teaser.js';

const TeaserHero = props => {
  return /*#__PURE__*/React$1.createElement(Teaser$1, _extends({}, props, {
    featured: true
  }));
};

export default TeaserHero;
